import { render, staticRenderFns } from "./BuyContractReport.vue?vue&type=template&id=ccfd1c58&"
import script from "./BuyContractReport.vue?vue&type=script&lang=js&"
export * from "./BuyContractReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports